var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[_c('p',{staticClass:"font-weight-bolder text-danger",style:(_vm.alertMessageStyle)},[_vm._v("\n                "+_vm._s(_vm.$t('exception.access_denied'))+"\n            ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }